




import { Params } from '../insights/abstract.component';
import { AreaChartComponent as Component, Config, Data } from '../insights/area-chart/area-chart.component';

export default {
  name: 'area-chart',
  props: {
    params: Object
  },
  data: function () {
    return {
      component: undefined
    };
  },
  computed: {
    componentParams: function (): Params<Config, Data> {
      return {
        config: {
          ...this.params.config,
          locale: this.$epb.locale
        },
        data: this.params.data
      };
    }
  },
  mounted: function (): void {
    this.component = new Component(this.$el, this.componentParams);
  },
  beforeDestroy: function (): void {
    this.component.destroy();
  },
  watch: {
    componentParams: function (componentParams: Params<Config, Data>): void {
      this.component.update(componentParams);
    }
  }
};

